const Loading = ({ text }) => {

    return (
        <div className="d-flex justify-content-center">
            <div className="d-flex align-items-center gap-2 flex-column">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">{text}</span>
                </div>
                {text && <span role="status">{text}</span>}
            </div>
        </div>
    );
};

export default Loading;